"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "METERS_PER_UNIT", {
  enumerable: true,
  get: function get() {
    return _Units.METERS_PER_UNIT;
  }
});
Object.defineProperty(exports, "Projection", {
  enumerable: true,
  get: function get() {
    return _Projection["default"];
  }
});
exports.addCommon = addCommon;
exports.addCoordinateTransforms = addCoordinateTransforms;
exports.addEquivalentProjections = addEquivalentProjections;
exports.addEquivalentTransforms = addEquivalentTransforms;
exports.addProjection = addProjection;
exports.addProjections = addProjections;
exports.clearAllProjections = clearAllProjections;
exports.clearUserProjection = clearUserProjection;
exports.cloneTransform = cloneTransform;
exports.createProjection = createProjection;
exports.createSafeCoordinateTransform = createSafeCoordinateTransform;
exports.createTransformFromCoordinateTransform = createTransformFromCoordinateTransform;
exports.disableCoordinateWarning = disableCoordinateWarning;
exports.equivalent = equivalent;
exports.fromLonLat = fromLonLat;
exports.fromUserCoordinate = fromUserCoordinate;
exports.fromUserExtent = fromUserExtent;
exports.fromUserResolution = fromUserResolution;
exports.get = get;
exports.getPointResolution = getPointResolution;
exports.getTransform = getTransform;
exports.getTransformFromProjections = getTransformFromProjections;
exports.getUserProjection = getUserProjection;
exports.identityTransform = identityTransform;
exports.setUserProjection = setUserProjection;
exports.toLonLat = toLonLat;
exports.toUserCoordinate = toUserCoordinate;
exports.toUserExtent = toUserExtent;
exports.toUserResolution = toUserResolution;
exports.transform = transform;
exports.transformExtent = transformExtent;
exports.transformWithProjections = transformWithProjections;
exports.useGeographic = useGeographic;

var _Projection = _interopRequireDefault(require("./proj/Projection.js"));

var _Units = _interopRequireWildcard(require("./proj/Units.js"));

var _epsg = require("./proj/epsg3857.js");

var _epsg2 = require("./proj/epsg4326.js");

var _projections = require("./proj/projections.js");

var _transforms = require("./proj/transforms.js");

var _extent = require("./extent.js");

var _math = require("./math.js");

var _coordinate = require("./coordinate.js");

var _sphere = require("./sphere.js");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @module ol/proj
 */

/**
 * The ol/proj module stores:
 * * a list of {@link module:ol/proj/Projection~Projection}
 * objects, one for each projection supported by the application
 * * a list of transform functions needed to convert coordinates in one projection
 * into another.
 *
 * The static functions are the methods used to maintain these.
 * Each transform function can handle not only simple coordinate pairs, but also
 * large arrays of coordinates such as vector geometries.
 *
 * When loaded, the library adds projection objects for EPSG:4326 (WGS84
 * geographic coordinates) and EPSG:3857 (Web or Spherical Mercator, as used
 * for example by Bing Maps or OpenStreetMap), together with the relevant
 * transform functions.
 *
 * Additional transforms may be added by using the http://proj4js.org/
 * library (version 2.2 or later). You can use the full build supplied by
 * Proj4js, or create a custom build to support those projections you need; see
 * the Proj4js website for how to do this. You also need the Proj4js definitions
 * for the required projections. These definitions can be obtained from
 * https://epsg.io/, and are a JS function, so can be loaded in a script
 * tag (as in the examples) or pasted into your application.
 *
 * After all required projection definitions are added to proj4's registry (by
 * using `proj4.defs()`), simply call `register(proj4)` from the `ol/proj/proj4`
 * package. Existing transforms are not changed by this function. See
 * examples/wms-image-custom-proj for an example of this.
 *
 * Additional projection definitions can be registered with `proj4.defs()` any
 * time. Just make sure to call `register(proj4)` again; for example, with user-supplied data where you don't
 * know in advance what projections are needed, you can initially load minimal
 * support and then load whichever are requested.
 *
 * Note that Proj4js does not support projection extents. If you want to add
 * one for creating default tile grids, you can add it after the Projection
 * object has been created with `setExtent`, for example,
 * `get('EPSG:1234').setExtent(extent)`.
 *
 * In addition to Proj4js support, any transform functions can be added with
 * {@link module:ol/proj.addCoordinateTransforms}. To use this, you must first create
 * a {@link module:ol/proj/Projection~Projection} object for the new projection and add it with
 * {@link module:ol/proj.addProjection}. You can then add the forward and inverse
 * functions with {@link module:ol/proj.addCoordinateTransforms}. See
 * examples/wms-custom-proj for an example of this.
 *
 * Note that if no transforms are needed and you only need to define the
 * projection, just add a {@link module:ol/proj/Projection~Projection} with
 * {@link module:ol/proj.addProjection}. See examples/wms-no-proj for an example of
 * this.
 */

/**
 * A projection as {@link module:ol/proj/Projection~Projection}, SRS identifier
 * string or undefined.
 * @typedef {Projection|string|undefined} ProjectionLike
 * @api
 */

/**
 * A transform function accepts an array of input coordinate values, an optional
 * output array, and an optional dimension (default should be 2).  The function
 * transforms the input coordinate values, populates the output array, and
 * returns the output array.
 *
 * @typedef {function(Array<number>, Array<number>=, number=): Array<number>} TransformFunction
 * @api
 */
var showCoordinateWarning = true;
/**
 * @param {boolean} [opt_disable = true] Disable console info about `useGeographic()`
 */

function disableCoordinateWarning(opt_disable) {
  var hide = opt_disable === undefined ? true : opt_disable;
  showCoordinateWarning = !hide;
}
/**
 * @param {Array<number>} input Input coordinate array.
 * @param {Array<number>} [opt_output] Output array of coordinate values.
 * @param {number} [opt_dimension] Dimension.
 * @return {Array<number>} Output coordinate array (new array, same coordinate
 *     values).
 */


function cloneTransform(input, opt_output, opt_dimension) {
  var output;

  if (opt_output !== undefined) {
    for (var i = 0, ii = input.length; i < ii; ++i) {
      opt_output[i] = input[i];
    }

    output = opt_output;
  } else {
    output = input.slice();
  }

  return output;
}
/**
 * @param {Array<number>} input Input coordinate array.
 * @param {Array<number>} [opt_output] Output array of coordinate values.
 * @param {number} [opt_dimension] Dimension.
 * @return {Array<number>} Input coordinate array (same array as input).
 */


function identityTransform(input, opt_output, opt_dimension) {
  if (opt_output !== undefined && input !== opt_output) {
    for (var i = 0, ii = input.length; i < ii; ++i) {
      opt_output[i] = input[i];
    }

    input = opt_output;
  }

  return input;
}
/**
 * Add a Projection object to the list of supported projections that can be
 * looked up by their code.
 *
 * @param {Projection} projection Projection instance.
 * @api
 */


function addProjection(projection) {
  (0, _projections.add)(projection.getCode(), projection);
  (0, _transforms.add)(projection, projection, cloneTransform);
}
/**
 * @param {Array<Projection>} projections Projections.
 */


function addProjections(projections) {
  projections.forEach(addProjection);
}
/**
 * Fetches a Projection object for the code specified.
 *
 * @param {ProjectionLike} projectionLike Either a code string which is
 *     a combination of authority and identifier such as "EPSG:4326", or an
 *     existing projection object, or undefined.
 * @return {Projection|null} Projection object, or null if not in list.
 * @api
 */


function get(projectionLike) {
  return typeof projectionLike === 'string' ? (0, _projections.get)(
  /** @type {string} */
  projectionLike) :
  /** @type {Projection} */
  projectionLike || null;
}
/**
 * Get the resolution of the point in degrees or distance units.
 * For projections with degrees as the unit this will simply return the
 * provided resolution. For other projections the point resolution is
 * by default estimated by transforming the `point` pixel to EPSG:4326,
 * measuring its width and height on the normal sphere,
 * and taking the average of the width and height.
 * A custom function can be provided for a specific projection, either
 * by setting the `getPointResolution` option in the
 * {@link module:ol/proj/Projection~Projection} constructor or by using
 * {@link module:ol/proj/Projection~Projection#setGetPointResolution} to change an existing
 * projection object.
 * @param {ProjectionLike} projection The projection.
 * @param {number} resolution Nominal resolution in projection units.
 * @param {import("./coordinate.js").Coordinate} point Point to find adjusted resolution at.
 * @param {import("./proj/Units.js").default} [opt_units] Units to get the point resolution in.
 * Default is the projection's units.
 * @return {number} Point resolution.
 * @api
 */


function getPointResolution(projection, resolution, point, opt_units) {
  projection = get(projection);
  var pointResolution;
  var getter = projection.getPointResolutionFunc();

  if (getter) {
    pointResolution = getter(resolution, point);

    if (opt_units && opt_units !== projection.getUnits()) {
      var metersPerUnit = projection.getMetersPerUnit();

      if (metersPerUnit) {
        pointResolution = pointResolution * metersPerUnit / _Units.METERS_PER_UNIT[opt_units];
      }
    }
  } else {
    var units = projection.getUnits();

    if (units == _Units["default"].DEGREES && !opt_units || opt_units == _Units["default"].DEGREES) {
      pointResolution = resolution;
    } else {
      // Estimate point resolution by transforming the center pixel to EPSG:4326,
      // measuring its width and height on the normal sphere, and taking the
      // average of the width and height.
      var toEPSG4326_1 = getTransformFromProjections(projection, get('EPSG:4326'));

      if (toEPSG4326_1 === identityTransform && units !== _Units["default"].DEGREES) {
        // no transform is available
        pointResolution = resolution * projection.getMetersPerUnit();
      } else {
        var vertices = [point[0] - resolution / 2, point[1], point[0] + resolution / 2, point[1], point[0], point[1] - resolution / 2, point[0], point[1] + resolution / 2];
        vertices = toEPSG4326_1(vertices, vertices, 2);
        var width = (0, _sphere.getDistance)(vertices.slice(0, 2), vertices.slice(2, 4));
        var height = (0, _sphere.getDistance)(vertices.slice(4, 6), vertices.slice(6, 8));
        pointResolution = (width + height) / 2;
      }

      var metersPerUnit = opt_units ? _Units.METERS_PER_UNIT[opt_units] : projection.getMetersPerUnit();

      if (metersPerUnit !== undefined) {
        pointResolution /= metersPerUnit;
      }
    }
  }

  return pointResolution;
}
/**
 * Registers transformation functions that don't alter coordinates. Those allow
 * to transform between projections with equal meaning.
 *
 * @param {Array<Projection>} projections Projections.
 * @api
 */


function addEquivalentProjections(projections) {
  addProjections(projections);
  projections.forEach(function (source) {
    projections.forEach(function (destination) {
      if (source !== destination) {
        (0, _transforms.add)(source, destination, cloneTransform);
      }
    });
  });
}
/**
 * Registers transformation functions to convert coordinates in any projection
 * in projection1 to any projection in projection2.
 *
 * @param {Array<Projection>} projections1 Projections with equal
 *     meaning.
 * @param {Array<Projection>} projections2 Projections with equal
 *     meaning.
 * @param {TransformFunction} forwardTransform Transformation from any
 *   projection in projection1 to any projection in projection2.
 * @param {TransformFunction} inverseTransform Transform from any projection
 *   in projection2 to any projection in projection1..
 */


function addEquivalentTransforms(projections1, projections2, forwardTransform, inverseTransform) {
  projections1.forEach(function (projection1) {
    projections2.forEach(function (projection2) {
      (0, _transforms.add)(projection1, projection2, forwardTransform);
      (0, _transforms.add)(projection2, projection1, inverseTransform);
    });
  });
}
/**
 * Clear all cached projections and transforms.
 */


function clearAllProjections() {
  (0, _projections.clear)();
  (0, _transforms.clear)();
}
/**
 * @param {Projection|string|undefined} projection Projection.
 * @param {string} defaultCode Default code.
 * @return {Projection} Projection.
 */


function createProjection(projection, defaultCode) {
  if (!projection) {
    return get(defaultCode);
  } else if (typeof projection === 'string') {
    return get(projection);
  } else {
    return (
      /** @type {Projection} */
      projection
    );
  }
}
/**
 * Creates a {@link module:ol/proj~TransformFunction} from a simple 2D coordinate transform
 * function.
 * @param {function(import("./coordinate.js").Coordinate): import("./coordinate.js").Coordinate} coordTransform Coordinate
 *     transform.
 * @return {TransformFunction} Transform function.
 */


function createTransformFromCoordinateTransform(coordTransform) {
  return (
    /**
     * @param {Array<number>} input Input.
     * @param {Array<number>} [opt_output] Output.
     * @param {number} [opt_dimension] Dimension.
     * @return {Array<number>} Output.
     */
    function (input, opt_output, opt_dimension) {
      var length = input.length;
      var dimension = opt_dimension !== undefined ? opt_dimension : 2;
      var output = opt_output !== undefined ? opt_output : new Array(length);

      for (var i = 0; i < length; i += dimension) {
        var point = coordTransform([input[i], input[i + 1]]);
        output[i] = point[0];
        output[i + 1] = point[1];

        for (var j = dimension - 1; j >= 2; --j) {
          output[i + j] = input[i + j];
        }
      }

      return output;
    }
  );
}
/**
 * Registers coordinate transform functions to convert coordinates between the
 * source projection and the destination projection.
 * The forward and inverse functions convert coordinate pairs; this function
 * converts these into the functions used internally which also handle
 * extents and coordinate arrays.
 *
 * @param {ProjectionLike} source Source projection.
 * @param {ProjectionLike} destination Destination projection.
 * @param {function(import("./coordinate.js").Coordinate): import("./coordinate.js").Coordinate} forward The forward transform
 *     function (that is, from the source projection to the destination
 *     projection) that takes a {@link module:ol/coordinate~Coordinate} as argument and returns
 *     the transformed {@link module:ol/coordinate~Coordinate}.
 * @param {function(import("./coordinate.js").Coordinate): import("./coordinate.js").Coordinate} inverse The inverse transform
 *     function (that is, from the destination projection to the source
 *     projection) that takes a {@link module:ol/coordinate~Coordinate} as argument and returns
 *     the transformed {@link module:ol/coordinate~Coordinate}.
 * @api
 */


function addCoordinateTransforms(source, destination, forward, inverse) {
  var sourceProj = get(source);
  var destProj = get(destination);
  (0, _transforms.add)(sourceProj, destProj, createTransformFromCoordinateTransform(forward));
  (0, _transforms.add)(destProj, sourceProj, createTransformFromCoordinateTransform(inverse));
}
/**
 * Transforms a coordinate from longitude/latitude to a different projection.
 * @param {import("./coordinate.js").Coordinate} coordinate Coordinate as longitude and latitude, i.e.
 *     an array with longitude as 1st and latitude as 2nd element.
 * @param {ProjectionLike} [opt_projection] Target projection. The
 *     default is Web Mercator, i.e. 'EPSG:3857'.
 * @return {import("./coordinate.js").Coordinate} Coordinate projected to the target projection.
 * @api
 */


function fromLonLat(coordinate, opt_projection) {
  disableCoordinateWarning();
  return transform(coordinate, 'EPSG:4326', opt_projection !== undefined ? opt_projection : 'EPSG:3857');
}
/**
 * Transforms a coordinate to longitude/latitude.
 * @param {import("./coordinate.js").Coordinate} coordinate Projected coordinate.
 * @param {ProjectionLike} [opt_projection] Projection of the coordinate.
 *     The default is Web Mercator, i.e. 'EPSG:3857'.
 * @return {import("./coordinate.js").Coordinate} Coordinate as longitude and latitude, i.e. an array
 *     with longitude as 1st and latitude as 2nd element.
 * @api
 */


function toLonLat(coordinate, opt_projection) {
  var lonLat = transform(coordinate, opt_projection !== undefined ? opt_projection : 'EPSG:3857', 'EPSG:4326');
  var lon = lonLat[0];

  if (lon < -180 || lon > 180) {
    lonLat[0] = (0, _math.modulo)(lon + 180, 360) - 180;
  }

  return lonLat;
}
/**
 * Checks if two projections are the same, that is every coordinate in one
 * projection does represent the same geographic point as the same coordinate in
 * the other projection.
 *
 * @param {Projection} projection1 Projection 1.
 * @param {Projection} projection2 Projection 2.
 * @return {boolean} Equivalent.
 * @api
 */


function equivalent(projection1, projection2) {
  if (projection1 === projection2) {
    return true;
  }

  var equalUnits = projection1.getUnits() === projection2.getUnits();

  if (projection1.getCode() === projection2.getCode()) {
    return equalUnits;
  } else {
    var transformFunc = getTransformFromProjections(projection1, projection2);
    return transformFunc === cloneTransform && equalUnits;
  }
}
/**
 * Searches in the list of transform functions for the function for converting
 * coordinates from the source projection to the destination projection.
 *
 * @param {Projection} sourceProjection Source Projection object.
 * @param {Projection} destinationProjection Destination Projection
 *     object.
 * @return {TransformFunction} Transform function.
 */


function getTransformFromProjections(sourceProjection, destinationProjection) {
  var sourceCode = sourceProjection.getCode();
  var destinationCode = destinationProjection.getCode();
  var transformFunc = (0, _transforms.get)(sourceCode, destinationCode);

  if (!transformFunc) {
    transformFunc = identityTransform;
  }

  return transformFunc;
}
/**
 * Given the projection-like objects, searches for a transformation
 * function to convert a coordinates array from the source projection to the
 * destination projection.
 *
 * @param {ProjectionLike} source Source.
 * @param {ProjectionLike} destination Destination.
 * @return {TransformFunction} Transform function.
 * @api
 */


function getTransform(source, destination) {
  var sourceProjection = get(source);
  var destinationProjection = get(destination);
  return getTransformFromProjections(sourceProjection, destinationProjection);
}
/**
 * Transforms a coordinate from source projection to destination projection.
 * This returns a new coordinate (and does not modify the original).
 *
 * See {@link module:ol/proj.transformExtent} for extent transformation.
 * See the transform method of {@link module:ol/geom/Geometry~Geometry} and its
 * subclasses for geometry transforms.
 *
 * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
 * @param {ProjectionLike} source Source projection-like.
 * @param {ProjectionLike} destination Destination projection-like.
 * @return {import("./coordinate.js").Coordinate} Coordinate.
 * @api
 */


function transform(coordinate, source, destination) {
  var transformFunc = getTransform(source, destination);
  return transformFunc(coordinate, undefined, coordinate.length);
}
/**
 * Transforms an extent from source projection to destination projection.  This
 * returns a new extent (and does not modify the original).
 *
 * @param {import("./extent.js").Extent} extent The extent to transform.
 * @param {ProjectionLike} source Source projection-like.
 * @param {ProjectionLike} destination Destination projection-like.
 * @param {number} [opt_stops] Number of stops per side used for the transform.
 * By default only the corners are used.
 * @return {import("./extent.js").Extent} The transformed extent.
 * @api
 */


function transformExtent(extent, source, destination, opt_stops) {
  var transformFunc = getTransform(source, destination);
  return (0, _extent.applyTransform)(extent, transformFunc, undefined, opt_stops);
}
/**
 * Transforms the given point to the destination projection.
 *
 * @param {import("./coordinate.js").Coordinate} point Point.
 * @param {Projection} sourceProjection Source projection.
 * @param {Projection} destinationProjection Destination projection.
 * @return {import("./coordinate.js").Coordinate} Point.
 */


function transformWithProjections(point, sourceProjection, destinationProjection) {
  var transformFunc = getTransformFromProjections(sourceProjection, destinationProjection);
  return transformFunc(point);
}
/**
 * @type {Projection|null}
 */


var userProjection = null;
/**
 * Set the projection for coordinates supplied from and returned by API methods.
 * This includes all API methods except for those interacting with tile grids.
 * @param {ProjectionLike} projection The user projection.
 * @api
 */

function setUserProjection(projection) {
  userProjection = get(projection);
}
/**
 * Clear the user projection if set.
 * @api
 */


function clearUserProjection() {
  userProjection = null;
}
/**
 * Get the projection for coordinates supplied from and returned by API methods.
 * Note that this method is not yet a part of the stable API.  Support for user
 * projections is not yet complete and should be considered experimental.
 * @return {Projection|null} The user projection (or null if not set).
 * @api
 */


function getUserProjection() {
  return userProjection;
}
/**
 * Use geographic coordinates (WGS-84 datum) in API methods.  This includes all API
 * methods except for those interacting with tile grids.
 * @api
 */


function useGeographic() {
  setUserProjection('EPSG:4326');
}
/**
 * Return a coordinate transformed into the user projection.  If no user projection
 * is set, the original coordinate is returned.
 * @param {Array<number>} coordinate Input coordinate.
 * @param {ProjectionLike} sourceProjection The input coordinate projection.
 * @return {Array<number>} The input coordinate in the user projection.
 */


function toUserCoordinate(coordinate, sourceProjection) {
  if (!userProjection) {
    return coordinate;
  }

  return transform(coordinate, sourceProjection, userProjection);
}
/**
 * Return a coordinate transformed from the user projection.  If no user projection
 * is set, the original coordinate is returned.
 * @param {Array<number>} coordinate Input coordinate.
 * @param {ProjectionLike} destProjection The destination projection.
 * @return {Array<number>} The input coordinate transformed.
 */


function fromUserCoordinate(coordinate, destProjection) {
  if (!userProjection) {
    if (showCoordinateWarning && !(0, _coordinate.equals)(coordinate, [0, 0]) && coordinate[0] >= -180 && coordinate[0] <= 180 && coordinate[1] >= -90 && coordinate[1] <= 90) {
      showCoordinateWarning = false; // eslint-disable-next-line no-console

      console.warn('Call useGeographic() from ol/proj once to work with [longitude, latitude] coordinates.');
    }

    return coordinate;
  }

  return transform(coordinate, userProjection, destProjection);
}
/**
 * Return an extent transformed into the user projection.  If no user projection
 * is set, the original extent is returned.
 * @param {import("./extent.js").Extent} extent Input extent.
 * @param {ProjectionLike} sourceProjection The input extent projection.
 * @return {import("./extent.js").Extent} The input extent in the user projection.
 */


function toUserExtent(extent, sourceProjection) {
  if (!userProjection) {
    return extent;
  }

  return transformExtent(extent, sourceProjection, userProjection);
}
/**
 * Return an extent transformed from the user projection.  If no user projection
 * is set, the original extent is returned.
 * @param {import("./extent.js").Extent} extent Input extent.
 * @param {ProjectionLike} destProjection The destination projection.
 * @return {import("./extent.js").Extent} The input extent transformed.
 */


function fromUserExtent(extent, destProjection) {
  if (!userProjection) {
    return extent;
  }

  return transformExtent(extent, userProjection, destProjection);
}
/**
 * Return the resolution in user projection units per pixel. If no user projection
 * is set, or source or user projection are missing units, the original resolution
 * is returned.
 * @param {number} resolution Resolution in input projection units per pixel.
 * @param {ProjectionLike} sourceProjection The input projection.
 * @return {number} Resolution in user projection units per pixel.
 */


function toUserResolution(resolution, sourceProjection) {
  if (!userProjection) {
    return resolution;
  }

  var sourceUnits = get(sourceProjection).getUnits();
  var userUnits = userProjection.getUnits();
  return sourceUnits && userUnits ? resolution * _Units.METERS_PER_UNIT[sourceUnits] / _Units.METERS_PER_UNIT[userUnits] : resolution;
}
/**
 * Return the resolution in user projection units per pixel. If no user projection
 * is set, or source or user projection are missing units, the original resolution
 * is returned.
 * @param {number} resolution Resolution in user projection units per pixel.
 * @param {ProjectionLike} destProjection The destination projection.
 * @return {number} Resolution in destination projection units per pixel.
 */


function fromUserResolution(resolution, destProjection) {
  if (!userProjection) {
    return resolution;
  }

  var sourceUnits = get(destProjection).getUnits();
  var userUnits = userProjection.getUnits();
  return sourceUnits && userUnits ? resolution * _Units.METERS_PER_UNIT[userUnits] / _Units.METERS_PER_UNIT[sourceUnits] : resolution;
}
/**
 * Creates a safe coordinate transform function from a coordinate transform function.
 * "Safe" means that it can handle wrapping of x-coordinates for global projections,
 * and that coordinates exceeding the source projection validity extent's range will be
 * clamped to the validity range.
 * @param {Projection} sourceProj Source projection.
 * @param {Projection} destProj Destination projection.
 * @param {function(import("./coordinate.js").Coordinate): import("./coordinate.js").Coordinate} transform Transform function (source to destiation).
 * @return {function(import("./coordinate.js").Coordinate): import("./coordinate.js").Coordinate} Safe transform function (source to destiation).
 */


function createSafeCoordinateTransform(sourceProj, destProj, transform) {
  return function (coord) {
    var sourceX = coord[0];
    var sourceY = coord[1];
    var transformed, worldsAway;

    if (sourceProj.canWrapX()) {
      var sourceExtent = sourceProj.getExtent();
      var sourceExtentWidth = (0, _extent.getWidth)(sourceExtent);
      worldsAway = (0, _coordinate.getWorldsAway)(coord, sourceProj, sourceExtentWidth);

      if (worldsAway) {
        // Move x to the real world
        sourceX = sourceX - worldsAway * sourceExtentWidth;
      }

      sourceX = (0, _math.clamp)(sourceX, sourceExtent[0], sourceExtent[2]);
      sourceY = (0, _math.clamp)(sourceY, sourceExtent[1], sourceExtent[3]);
      transformed = transform([sourceX, sourceY]);
    } else {
      transformed = transform(coord);
    }

    if (worldsAway && destProj.canWrapX()) {
      // Move transformed coordinate back to the offset world
      transformed[0] += worldsAway * (0, _extent.getWidth)(destProj.getExtent());
    }

    return transformed;
  };
}
/**
 * Add transforms to and from EPSG:4326 and EPSG:3857.  This function is called
 * by when this module is executed and should only need to be called again after
 * `clearAllProjections()` is called (e.g. in tests).
 */


function addCommon() {
  // Add transformations that don't alter coordinates to convert within set of
  // projections with equal meaning.
  addEquivalentProjections(_epsg.PROJECTIONS);
  addEquivalentProjections(_epsg2.PROJECTIONS); // Add transformations to convert EPSG:4326 like coordinates to EPSG:3857 like
  // coordinates and back.

  addEquivalentTransforms(_epsg2.PROJECTIONS, _epsg.PROJECTIONS, _epsg.fromEPSG4326, _epsg.toEPSG4326);
}

addCommon();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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